import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';
import * as classnames from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment/moment';

class Day extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.bookingEntity !== this.props.bookingEntity;
  }

  render() {
    const isBookedDay = this.props.bookingEntity !== undefined;

    // start date project
    this.startDateProject = moment(this.props.project.start_date);
    // end date project
    this.endDateProject = moment(this.props.project.end_date);
    this.dateRange = [this.startDateProject, this.endDateProject];

    const day = {
      name: this.props.date.format('dd').substring(0, 1),
      number: this.props.date.date(),
      isClickable: this.isClickable(isBookedDay, this.props.isSameSource),
      isBookedDay,
      isWeekend: this.isWeekend(this.props.date),
      isCurrentMonth: this.props.date.month() === this.props.currentMonth.month(),
      isToday: this.props.date.isSame(new Date(), 'day'),
      isInDateRange: this.isInDateRange(this.props.date),
      isFromSameSource: this.props.isSameSource,
      date: this.props.date
    };

    const classes = classnames({
      today: day.isToday,
      'different-month': !day.isCurrentMonth,
      'not-from-same-source': !day.isFromSameSource,
      'is-selected': day.isBookedDay && day.isFromSameSource,
      'is-weekend': day.isWeekend,
      'in-date-range': day.isInDateRange,
      'out-date-range': !day.isInDateRange,
      clickable: day.isClickable,
      'not-clickable': !day.isClickable,
      'out-of-order': this.props.bookableEntity && !this.props.bookableEntity.status
    });

    return (
      <Table.Cell className="day-cell">
        <div
          className={`day-box ${classes}`}
          onClick={() =>
            this.props.clickHandler(day, this.props.bookableEntity, this.props.bookingEntity)
          }
        >
          <div className="day">
            <div className="day-content">
              {this.props.showDay ? (
                <div>
                  <span className="day-number">{day.number}</span> <br />
                  <span className="day-name">{this.props.date.format('dd').substring(0, 1)}</span>
                  {this.props.date.date() === 1 ? (
                    <span className="month-label">{this.props.date.format('MMMM, YYYY')}</span>
                  ) : (
                    ''
                  )}
                </div>
              ) : (
                ''
              )}

              {isBookedDay && this.props.isSameSource ? (
                <i className="icon-data-ok-round icon" />
              ) : (
                ''
              )}
              {this.props.bookableEntity && !this.props.bookableEntity.status ? (
                <i className="icon-session-log-not-ok icon" />
              ) : (
                ''
              )}
              {!this.props.isSameSource && isBookedDay ? (
                <i className="icon-session-log-not-ok icon" />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </Table.Cell>
    );
  }

  /**
   * Check if date is in start and end date project
   * @param date
   * @returns {boolean}
   */
  isInDateRange(date) {
    return (
      date.isSame(this.dateRange[0]) ||
      date.isSame(this.dateRange[1]) ||
      date.isBetween(this.dateRange[0], this.dateRange[1])
    );
  }

  /**
   * Check if date clickable
   * @param isBookedDay
   * @param isSameSource
   * @returns {*}
   */
  isClickable(isBookedDay, isSameSource) {
    if (!this.props.bookableEntity) return false;

    return (
      (!isBookedDay &&
        this.isInDateRange(this.props.date) &&
        this.props.bookableEntity.status !== 'broken') ||
      isSameSource
    );
  }

  isWeekend(date) {
    const weekend = ['sat', 'sun'];
    const day = date.format('ddd').toLowerCase();
    return weekend.find(d => d === day);
  }
}

Day.propTypes = {
  className: PropTypes.string,
  clickHandler: PropTypes.func,
  showDay: PropTypes.bool,
  bookingEntity: PropTypes.object,
  date: PropTypes.object,
  bookings: PropTypes.array,
  bookingEntityType: PropTypes.string
};

Day.defaultProps = {
  className: '',
  clickHandler: null
};

export default connect(state => ({
  project: state.projects.single.active,
  currentMonth: state.projects.single.booking.currentMonth
}))(Day);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/booking/Day.js